// Card Stato Compatibilità: check moduli, inverter, DC/AC e storage
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { CheckCircle2, XCircle, AlertTriangle } from 'lucide-react';

export function StatoCompatibilitaCard({ calculations, validation, storageEnabled }) {
  return (
    <Card className="lg:col-span-5 bg-white border-zinc-200 rounded-2xl shadow-sm" data-testid="stato-compatibilita-card">
      <CardHeader className="pb-4">
        <CardTitle className="text-lg font-bold text-zinc-900 flex items-center gap-2">
          <CheckCircle2 className="h-5 w-5 text-zinc-500" />
          Stato Compatibilità
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-0">
        {/* Check moduli */}
        <div className="flex items-center justify-between py-3 border-b border-zinc-100">
          <span className="text-sm text-zinc-700">Moduli configurati</span>
          {calculations.moduliCount > 0 ? (
            <div className="flex items-center gap-2">
              <Badge variant="outline" className="font-mono text-xs">{calculations.moduliCount} pz</Badge>
              <CheckCircle2 className="h-5 w-5 text-emerald-500" />
            </div>
          ) : (
            <XCircle className="h-5 w-5 text-rose-500" />
          )}
        </div>

        {/* Check inverter */}
        <div className="flex items-center justify-between py-3 border-b border-zinc-100">
          <span className="text-sm text-zinc-700">Inverter configurato</span>
          {calculations.inverterCount > 0 ? (
            <div className="flex items-center gap-2">
              <Badge variant="outline" className="font-mono text-xs">{calculations.inverterCount} pz</Badge>
              <CheckCircle2 className="h-5 w-5 text-emerald-500" />
            </div>
          ) : (
            <XCircle className="h-5 w-5 text-rose-500" />
          )}
        </div>

        {/* Check rapporto DC/AC */}
        <div className="flex items-center justify-between py-3 border-b border-zinc-100">
          <span className="text-sm text-zinc-700">Rapporto DC/AC</span>
          {calculations.dcAcStatus.status === 'ok' ? (
            <CheckCircle2 className="h-5 w-5 text-emerald-500" />
          ) : calculations.dcAcStatus.status === 'warning' ? (
            <AlertTriangle className="h-5 w-5 text-amber-500" />
          ) : calculations.dcAcStatus.status === 'error' ? (
            <XCircle className="h-5 w-5 text-rose-500" />
          ) : (
            <span className="text-zinc-400 text-sm">-</span>
          )}
        </div>

        {/* Compatibilità storage */}
        {storageEnabled && (
          <div className="flex items-center justify-between py-3">
            <span className="text-sm text-zinc-700">Compatibilità storage</span>
            {validation.warnings.some(w => w.field === 'STORAGE_COMPAT') ? (
              <AlertTriangle className="h-5 w-5 text-amber-500" />
            ) : calculations.storageCount > 0 ? (
              <CheckCircle2 className="h-5 w-5 text-emerald-500" />
            ) : (
              <span className="text-zinc-400 text-sm">-</span>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
